//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from 'vuex'
export default {
  name: 'FI',
  data() {
    return {
      form: {
        cm: '',
        sex: '',
        weight: '',
        oldWeight: '',
        hct: '',
        bs: '',
      },
      cmList: [
        { value: '0', name: '基于体重减轻量估算' },
        { value: '1', name: '基于血细胞比容估算' },
        { value: '2', name: '基于血钠浓度估算' },
      ],
      sexList: [
        { value: '0', name: '男' },
        { value: '1', name: '女' },
      ],
      hasScore: false,
      disabled: false,
    }
  },
  created() {
    this.hideLoad()
  },
  methods: {
    ...mapMutations(['hideLoad']),
  },
  computed: {
    /** 计算公式结果 */
    score() {
      let self = this
      let form = JSON.parse(JSON.stringify(self.form))
      if (form.cm == 0 && form.sex == '') {
        form.sex = '0'
      }
      if (form.cm == 0 && form.hct == '') {
        form.hct = '0'
      }
      if (form.cm == 0 && form.bs == '') {
        form.bs = '0'
      }
      if (form.cm == 1 && form.oldWeight == '') {
        form.oldWeight = '0'
      }
      if (form.cm == 1 && form.bs == '') {
        form.bs = '0'
      }
      if (form.cm == 2 && form.oldWeight == '') {
        form.oldWeight = '0'
      }
      if (form.cm == 2 && form.hct == '') {
        form.hct = '0'
      }
      let flag = true
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          console.log(form, 'form');
          if (!form[key]) {
            flag = false
          } else {
            if (form[key] == '---') {
              flag = false
            } else {
              form[key] = Number(form[key])
            }
          }
        }
      }
      if (!flag) {
        self.hasScore = false
        return '--'
      } else {
        let result
        let num
        let num1
        if (form.cm == 0) {
          num = (form.oldWeight - form.weight) * 30
          num1 = (form.oldWeight - form.weight) * 40
          result = num + '~' + num1
        } else if (form.cm == 1) {
          if (form.sex == 0) {
            result = (((form.hct - 0.48) / 0.48) * form.weight * 200).toFixed(1)
          } else {
            result = (((form.hct - 0.42) / 0.42) * form.weight * 200).toFixed(1)
          }
        }
        else if (form.cm == 2) {
          if (form.sex == 0) {
            result = (4 * form.weight * (form.bs - 142)).toFixed(1)
          } else {
            result = (3 * form.weight * (form.bs - 142)).toFixed(1)
          }
        }
        self.hasScore = true
        return String(result)
      }
    }
  },


}



// WEBPACK FOOTER //
// ./src/pages/formulas/NewFormulas/FI.vue